import styled from 'styled-components';

export const NavigatorEmailLink = styled.a`
  text-decoration: underline;
`;
